var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.src)?_c('nuxt-img',_vm._b({attrs:{"quality":_vm.quality.toString()},on:{"load":function($event){return _vm.$emit('load')}}},'nuxt-img',_vm.$props,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }